module.exports = __webpack_public_path__ + "static/media/yuntaishan_mobile.d8b5eff3.png";